import { Box, Text } from '@vouched.id/vault';
import React from 'react';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import { Dropdown } from '../Dropdown';
import { SingleSpanTable } from '../SingleSpanTable';
import { DropdownStatusIcon } from '../utils';
import { AMLCaption } from './AMLCaption';
import { AmlLinkIcon, AmlLinkParentStyles, AmlLinkStyles } from 'components/account/jobs-v2/dropdowns/AML/AmlLinkIcon';
import { AmlV2Results } from 'components/account/jobs-v2/dropdowns/AML/AmlV2Results';
import { getRequestItemEntries } from 'components/account/jobs-v2/dropdowns/AML/amlV2Utils';
export const AmlV2CompletedResult = ({ job, jobStatus }) => {
    const { id: jobSid } = useParams();
    const isAdminRoute = useLocation().pathname.includes('/admin');
    return (React.createElement(Dropdown, { statusIcon: React.createElement(DropdownStatusIcon, { dropdownHasRejections: false, dropdownHasWarnings: job.initialScreening.approved === false, jobStatus: job.initialScreening.status, parentJobStatus: jobStatus }), title: "AML" },
        React.createElement(Box, null,
            React.createElement(AMLCaption, null),
            job.monitoring && (React.createElement(Box, { marginBottom: "spacing.large", paddingX: "spacing.large", paddingY: "spacing.default", style: AmlLinkParentStyles, width: "fit-content" },
                React.createElement(NavLink, { state: { job }, style: AmlLinkStyles, to: `${isAdminRoute ? '/admin' : '/account'}/jobs/${jobSid}/monitoring` },
                    React.createElement(Text, null, "View Monitoring results "),
                    React.createElement(AmlLinkIcon, null)))),
            React.createElement(SingleSpanTable, { header: "Submitted", items: getRequestItemEntries(job.request), numColumns: 2 }),
            job.initialScreening.risks.length > 0 ? (React.createElement(AmlV2Results, { risks: job.initialScreening.risks })) : null)));
};
